/**
 * NetworkGraphEditor
 *
 * Property editor for network graph configuration
 */

import React from 'react';
import { ChartBaseEditor, type ChartBaseConfig } from './ChartBaseEditor';
import { TextPropertyEditor } from '../../BaseEditors/TextPropertyEditor';
import { NumberPropertyEditor } from '../../BaseEditors/NumberPropertyEditor';

export interface NetworkGraphEditorProps {
  config: Partial<ChartBaseConfig & {
    sourceKey?: string;
    targetKey?: string;
    labelKey?: string;
    nodeRadius?: number;
  }>;
  onChange: (config: Partial<ChartBaseConfig>) => void;
}

export const NetworkGraphEditor: React.FC<NetworkGraphEditorProps> = ({ config, onChange }) => {
  return (
    <ChartBaseEditor config={config} onChange={onChange} chartType="Network Graph" showAxes={false}>
      <div className="chart-editor__section">
        <h3 className="chart-editor__section-title">Network Options</h3>

        <TextPropertyEditor
          label="Source Key"
          value={(config.sourceKey as string) || 'source'}
          onChange={(sourceKey) => onChange({ ...config, sourceKey })}
          helpText="Property for connection source"
          required
        />

        <TextPropertyEditor
          label="Target Key"
          value={(config.targetKey as string) || 'target'}
          onChange={(targetKey) => onChange({ ...config, targetKey })}
          helpText="Property for connection target"
          required
        />

        <TextPropertyEditor
          label="Label Key"
          value={(config.labelKey as string) || 'label'}
          onChange={(labelKey) => onChange({ ...config, labelKey })}
          helpText="Property for node labels (optional)"
        />

        <NumberPropertyEditor
          label="Node Radius"
          value={(config.nodeRadius as number) || 15}
          onChange={(nodeRadius) => onChange({ ...config, nodeRadius })}
          min={5}
          max={50}
          step={2}
          suffix="px"
        />
      </div>
    </ChartBaseEditor>
  );
};

NetworkGraphEditor.displayName = 'NetworkGraphEditor';
